import IconType from './iconType';

export default function BlogIcon({
  width = 16,
  height = 16,
  color = '#667085',
}: IconType) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5275_3644)">
        <path
          d="M2 12C1.60444 12 1.21776 12.1173 0.88886 12.3371C0.559962 12.5568 0.303617 12.8692 0.152242 13.2346C0.000866572 13.6001 -0.0387401 14.0022 0.0384303 14.3902C0.115601 14.7781 0.306082 15.1345 0.585787 15.4142C0.865492 15.6939 1.22186 15.8844 1.60982 15.9616C1.99778 16.0387 2.39992 15.9991 2.76537 15.8478C3.13082 15.6964 3.44318 15.44 3.66294 15.1111C3.8827 14.7822 4 14.3956 4 14C3.99948 13.4697 3.78859 12.9613 3.41363 12.5864C3.03868 12.2114 2.53027 12.0005 2 12Z"
          fill={color}
        />
        <path
          d="M2 6C1.73478 6 1.48043 6.10536 1.29289 6.29289C1.10536 6.48043 1 6.73478 1 7C1 7.26522 1.10536 7.51957 1.29289 7.70711C1.48043 7.89464 1.73478 8 2 8C3.59077 8.00173 5.11588 8.63443 6.24073 9.75927C7.36557 10.8841 7.99827 12.4092 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8946 8.73478 15 9 15C9.26522 15 9.51957 14.8946 9.70711 14.7071C9.89464 14.5196 10 14.2652 10 14C9.99774 11.879 9.15416 9.84544 7.65436 8.34564C6.15456 6.84584 4.12104 6.00226 2 6Z"
          fill={color}
        />
        <path
          d="M2 0C1.73478 0 1.48043 0.105357 1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1C1 1.26522 1.10536 1.51957 1.29289 1.70711C1.48043 1.89464 1.73478 2 2 2C5.18153 2.00348 8.23176 3.26887 10.4814 5.51856C12.7311 7.76824 13.9965 10.8185 14 14C14 14.2652 14.1054 14.5196 14.2929 14.7071C14.4804 14.8946 14.7348 15 15 15C15.2652 15 15.5196 14.8946 15.7071 14.7071C15.8946 14.5196 16 14.2652 16 14C15.9957 10.2883 14.5193 6.72986 11.8947 4.10528C9.27014 1.48071 5.7117 0.00432716 2 0V0Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5275_3644">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
